import type { ReactNode } from "react";

interface BadgeProps {
  children: ReactNode;
  variant?: "default" | "accent" | "muted";
  className?: string;
}

const variants = {
  default: "bg-bg-elevated text-text-secondary",
  accent: "bg-accent/15 text-accent-bright",
  muted: "bg-bg-surface text-text-muted",
};

export function Badge({
  children,
  variant = "default",
  className = "",
}: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${variants[variant]} ${className}`}
    >
      {children}
    </span>
  );
}
